module.exports = __webpack_public_path__ + "static/alida-b5093b3a8a38bf91f658b45dddd517ef.jpg";